// extracted by mini-css-extract-plugin
module.exports = {"Container":"TagsFilter_Container__1Rmmw","Open":"TagsFilter_Open__2xw1o","Controls":"TagsFilter_Controls__1HQfr"};